export default "__VITE_ASSET__nhmm9DnS__"